// src/com/trans_plan/TransPlanGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN Apollo Graphql
 * 운송요청 배차내역 테이블
 * Project: NewTOP for cloud
 * 2024-11-27 14:09:53 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const TRANS_PLAN_LIST_PART = gql`
fragment TransPlanListPart on TransPlan {
    planId
    dcCd
    arriveId
    storeId
    comId
    custId
    dcStaffName
    agentStaffName
    cargoStaffName
    cargoTel
    planDate
    planTime
    hocha
    transTypeCd
    txStage
    vehTypeId
    vehTypeName
    shprReqTime
    dptrReqTime
    arrReqTime
    dockno
    charge
    addCharge
    note
    reqStateFlag
    transFlag
    vehInfoSeq
    vehPlates
    vehAlias
    driverName
    driverMobile
    bol1
    bol2
    bol3
    loadCount
    loadStTime
    loadEnTime
    prosDptrTime
    prosArrTime
    sealNo1
    sealNo2
    sealNo3
    loadStaffName
    unsoldBol
    unsoldPallet
    unsoldCount
    memo
    inputArrTime
    traceStatus
    regTypeCd
    endFlag
    zipgiBool
    inputDptrTime
    printDate
    printUser
    inputTempF
    inputTempM
    inputTempR
    regDate
    regUser
    dcName
    dcTypeCd
    dcTypeName
    comName
    transPosYn
    storeName
    gpsTime
    location
    lat
    lon
    xDist
    yDist
    distKm
    speed
    direction
    irAction
    posSys
    tempr1
    tempr2
    tempr3
    insertTime
    inputArriveTimeBool
}
`;


export const LIST_TRANS_PLAN = gql`
${TRANS_PLAN_LIST_PART}
query ListTransPlan {
    transPlanList {
        ...TransPlanListPart
    }
}
`;

// 운송요청 작성. 상온의 경우 자동배차와 동기화
export const ADD_TRANS_PLAN = gql`
mutation AddTransPlan($transPlan:InputTransPlanAdd!) {
	transPlanAdd(transPlan: $transPlan) {
		ok
		message
        detail
	}
}
`;

// 운송요청 수정. 상온의 경우 자동배차와 동기화
export const EDIT_TRANS_PLAN = gql`
mutation EditTransPlan($transPlan:InputTransPlanEdit!) {
	transPlanEdit(transPlan: $transPlan) {
		ok
		message
        detail
	}
}
`;

// 운송요청 삭제. 상온의 경우 자동배차와 동기화
// 동적 있을 경우 동적해제
export const REMOVE_TRANS_PLAN = gql`
mutation RemoveTransPlan($transPlan:InputTransPlanRemove!) {
	transPlanRemove(transPlan: $transPlan) {
		ok
		message
        detail
	}
}
`;

/*
transPlanRemoveAll(transPlanList: [String!]!): CommonResponse! # 운송요청 일괄 삭제

*/
export const REMOVE_ALL_TRANS_PLAN = gql`
mutation RemoveAllTransPlan($transPlanList: [String!]!) {
    transPlanRemoveAll(transPlanList: $transPlanList) {
        ok
        message
    }
}
`;

// transPlanSendSmsForReady(planId: String!): CommonResponse!
export const SEND_SMS_TRANS_PLAN_FOR_READY = gql`
mutation SendSmsTransPlanForReady($planId: String!) {
    transPlanSendSmsForReady(planId: $planId) {
        ok
        message
    }
}
`;

// transPlanSendSmsForDepart(planId: String!): CommonResponse!
export const SEND_SMS_TRANS_PLAN_FOR_DEPART = gql`
mutation SendSmsTransPlanForDepart($planId: String!) {
    transPlanSendSmsForDepart(planId: $planId) {
        ok
        message
    }
}
`;


// 운송요청에 차량을 배차
// 기존 차량이 있었던 경우 기존 차량의 동적해제 점검
// 배체제한 확인 및 변경.
//transPlanSetTruck(transPlan: InputTransPlanSetTruck!): CommonResponse!
export const SET_TRANS_PLAN_TRUCK = gql`
mutation SetTransPlanTruck($transPlan: InputTransPlanSetTruck!) {
    transPlanSetTruck(transPlan: $transPlan) {
        ok
        message
    }
}
`;

// 운송요청에서 차량배정을 해제.
// 동적정보 확인 및 변경.
// 배차제한 확인 및 변경.
//transPlanOffTruck(planId: String!): CommonResponse!
export const OFF_TRANS_PLAN_TRUCK = gql`
mutation OffTransPlanTruck($planId: String!) {
    transPlanOffTruck(planId: $planId) {
        ok
        message
    }
}
`;
//transPlanSendGuideSms(planId: String!): CommonResponse!
export const SEND_TRANS_PLAN_GUIDE_SMS = gql`
mutation SendTransPlanGuideSms($planId: String!) {
    transPlanSendGuideSms(planId: $planId) {
        ok
        message
    }
}
`;

/*

input InputTransPlanBindUploadItem {
    dcCd: String!
    planDate: String!
    bindText: String!
}

# Data definition for pr_trans_plan_upload
input InputTransPlanUploadItem {
    dcCd: String!
    storeId: String!
    comId: String!
    planDate: String!
    hocha: Int!
    transTypeCd: String
    vehTypeId: String!
    shprReqTime: String!
    dptrReqTime: String!
    arrReqTime: String!
    dockno: String
    addCharge: Int
    note: String
    zipgiBool: Boolean
    vehPlates: String
    driverName: String
    driverMobile: String
}

{
    "storeId": "171",
    "hocha": 2,
    "vehTypeId": "59",
    "comId": "2012091004",
    "shprReqTime": "2025-03-10 04:40:00",
    "dptrReqTime": "2025-03-10 05:30:00",
    "arrReqTime": "2025-03-10 06:30:00",
    "dockno": "26",
    "addCharge": 0,
    "note": "[171085]천안신방점->천안점 ",
    "vehPlates": "충남83바8318",
    "driverName": "심상수",
    "driverMobile": "010-4714-7144",
    "dcCd": "981",
    "planDate": "2025-03-10",
    "zipgiBool": false
}

# 일괄업로드. InputTransPlanUploadItem 목록 + InputTransPlanBindUploadItem 목록
input InputTransPlanUpload {
    transPlanList: [InputTransPlanUploadItem!]!
    transPlanBindList: [InputTransPlanBindUploadItem!]
}

type TransPlanUploadItemResult {
    dcCd: String!
    storeId: String!
    planDate: String!
    hocha: Int!
    ok: Boolean!
    message: String
}

type TransPlanBindUploadItemResult {
    dcCd: String!
    planDate: String!
    bindText: String!
    ok: Boolean!
    message: String
}

type ResponseWithTransPlanUpload {
    ok: Boolean!
    message: String
    list: [TransPlanUploadItemResult!]!
    bindList: [TransPlanBindUploadItemResult!]
}

transPlanUpload(transPlanUpload: InputTransPlanUpload!): ResponseWithTransPlanUpload!

*/

// transPlanUpload(transPlanUpload: InputTransPlanUpload!): ResponseWithTransPlanUpload!
export const UPLOAD_TRANS_PLAN = gql`
mutation UploadTransPlan($transPlanPackage: InputTransPlanUpload!) {
    transPlanUpload(transPlanPackage: $transPlanPackage) {
        ok
        message
        list {
            dcCd
            storeId
            planDate
            hocha
            ok
            message
        }
        bindList {
            dcCd
            planDate
            bindText
            ok
            message
        }
    }
}
`;

// 홈플러스 배차등록
// transPlanSetCompany(transPlan: InputTransPlanSetCompany!): CommonResponse! # 운송사 설정
export const SET_TRANS_PLAN_COMPANY = gql`
mutation SetTransPlanCompany($transPlan: InputTransPlanSetCompany!) {
    transPlanSetCompany(transPlan: $transPlan) {
        ok
        message
    }
}
`;

